<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-5 pb-4">
          <span class="ft12Black">
            CARTA DE INSTRUCCIÓN DE ENTREGA DE PRÉSTAMO DIRECTO
          </span>
        </div>
        <div class="col-12 text-justify">
          <br />
          <span class="ft13Black">
            GPI AUTO COMERCIAL SAPI DE C.V.
          </span>
          <br /><br />
          <span class="ft13Black">
            APRECIABLES SEÑORES:
          </span>
          <br /><br />
          <span class="ft12">
            Con referencia al contrato de apertura de crédito simple con
            garantía prendaria sin transmisión de la posesión que el día de hoy
            celebré con ustedes, me permito autorizar a instruirles el que sin
            ninguna responsabilidad por su parte, en mi nombre y por mi cuenta,
            entreguen la cantidad de
            <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
              ${{ data.monto_a_finaciar }}
            </span>
            como el producto liquido del préstamo
            derivado de dicho contrato, a
            <br />
            <span v-bind:class="{ marca: data.showMarca }" class="ft11Black">
              {{ data.nombre_cliente }}
            </span>
            el cheque numero
            <span v-bind:class="{ marca: data.showMarca }" class="ft11Black">
              {{ data.referencia_banco }}
            </span>
            toda vez que con la empresa he convenido dicho préstamo para la adquisición
            de un vehículo. Dicha entrega del producto liquido del préstamo,
            deberá realizarse de acuerdo al requerimiento escrito que a
            <span class="ft11Black">GPI AUTO COMERCIAL S.A DE C.V</span>
            formule, precisando que, en el momento en que decidiera no realizar
            la adquisición del servicio, el (la) suscrito (a) por escrito,
            oportunamente lo comunicare a las partes interesadas, junto con la
            instrucción de cancelación de dicho préstamo.
            <br />
            Ambos contratantes convienen que
            <span class="ft11Black"> GPI AUTO COMERCIAL SAPI DE C.V.</span> de
            acuerdo a lo establecido se reserva el dominio del bien referido en
            la factura
            <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_factura }}
            </span>
            DEL
            <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_factura }}</span
            >, expedida por
            <span class="ft12Black"  v-bind:class="{ marca: data.showMarca }">
              {{ data.emisor_factura }}</span
            >,
            <br />
            <br />
            Descripción:
            <br />
            <span class="ft11Black">
              Marca:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.marca_vehiculo }}</span
              ><br />
              Modelo:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.modelo_vehiculo }}</span
              ><br />
              Año:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.año_vehiculo }}</span
              ><br />
              Número de Motor:
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.numero_motor_vehiculo }}</span
              ><br />
            </span>
            <br />
            Asi como el original de la factura antes mencionada, materia del
            presente contrato, hasta que el precio pactado y derivaciones
            legales estén totalmente pagados.
            <br />
            <br />
            Además, certifico que he leído y firmado el contrato de préstamo, el
            pagaré correspondiente, el convenio de aceptación del vehículo en
            las condiciones en que se encuentra, el endoso de la factura
            original, la entrega de las últimas tenencias, el último pago de
            placas, y he recibido el número de la cuenta bancaria referenciada
            en donde debo hacer los pagos en los vencimientos estipulados,
            también ha quedado debidamente asegurado el vehículo, con póliza de
            su empresa e instalado el sistema inmovilizador.
            <br />
            <br />
            Este documento se firma
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}.
            </span>
           </span>
        </div>
        <div class="col-12 row pt-5">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-top border-dark text-center ">
            <span class="ft12Black">
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.nombre_cliente }}
              </span>
              <br />
              ATENTAMENTE
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/InstruccionEntregaPrestamoDirecto.vue